import { useEffect, useState } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { apiGet, type Provider } from "../api/client";
import { Avatar } from "../components/Avatar";

export function TeamProviderPage() {
  const { id } = useParams();
  const { pathname } = useLocation();
  const [provider, setProvider] = useState<Provider | null>(null);
  const [policies, setPolicies] = useState<
    Array<{
      ptype?: string;
      charge?: number;
      hours_before?: number;
      active?: boolean;
      name?: string;
    }>
  >([]);
  const [types, setTypes] = useState<
    Array<{ name: string; minutes?: number; duration?: number }>
  >([]);
  const tab = pathname.includes("/policies")
    ? "policies"
    : pathname.includes("/atypes")
      ? "atypes"
      : "sched";

  useEffect(() => {
    if (!id) return;
    apiGet<Provider>(`/providers/${id}`).then(setProvider);
    apiGet<Array<{ office_policies: typeof policies }>>("/office_policies/-1", {
      "ids[]": id,
    }).then((d) => setPolicies(d?.[0]?.office_policies ?? []));
    apiGet<Array<{ types: typeof types }>>("/appointment_types", {
      "ids[]": id,
      parent_type: "Personnel",
    }).then((d) => setTypes(d?.[0]?.types ?? []));
  }, [id]);

  if (!provider) {
    return (
      <div className="ne__empty-message">
        <p>Loading…</p>
      </div>
    );
  }

  return (
    <>
      <header className="ne__page-header ne__page-header--tabs">
        <div className="ne__page-header__header">
          <div className="ne__page-header__provider">
            <Avatar src={provider.profile_url} alt={provider.name} />
            <h2 className="ne__page-header__title">
              {provider.name}
              {provider.title ? `, ${provider.title}` : ""}
            </h2>
          </div>
        </div>
        <ul className="ne__tab__group">
          <li>
            <NavLink
              className={({ isActive }) =>
                `ne__tab${isActive || tab === "sched" ? " active" : ""}`
              }
              to={`/app/team/${id}/sched`}
            >
              Schedule
            </NavLink>
          </li>
          <li>
            <NavLink
              className={({ isActive }) => `ne__tab${isActive ? " active" : ""}`}
              to={`/app/team/${id}/atypes`}
            >
              Appointment Types
            </NavLink>
          </li>
          <li>
            <NavLink
              className={({ isActive }) => `ne__tab${isActive ? " active" : ""}`}
              to={`/app/team/${id}/policies`}
            >
              Policies
            </NavLink>
          </li>
        </ul>
      </header>

      <div className="ne__team__view">
        {tab === "sched" ? (
          <div className="ne__prov-sched">
            <h3 className="ne__h3">Working hours</h3>
            <p>Mon–Fri · 9:00 AM – 5:00 PM at assigned locations</p>
          </div>
        ) : null}

        {tab === "atypes" ? (
          <div className="ne__table__padding">
            <table className="ne__table">
              <thead>
                <tr>
                  <th className="ne__table__eyebrow">Type</th>
                  <th className="ne__table__eyebrow">Duration</th>
                </tr>
              </thead>
              <tbody>
                {types.map((t, i) => (
                  <tr key={i}>
                    <td>{t.name}</td>
                    <td>{t.minutes || t.duration} min</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}

        {tab === "policies" ? (
          <div className="ne__table__padding">
            <h3 className="ne__h3">Edit policies for {provider.name}</h3>
            <table className="ne__table">
              <thead>
                <tr>
                  <th className="ne__table__eyebrow">Policy Type</th>
                  <th className="ne__table__eyebrow">Charge</th>
                  <th className="ne__table__eyebrow">Hours notice</th>
                  <th className="ne__table__eyebrow">In effect</th>
                  <th className="ne__table__eyebrow">Name</th>
                </tr>
              </thead>
              <tbody>
                {policies.map((p, i) => (
                  <tr key={i}>
                    <td>{p.ptype}</td>
                    <td>{p.charge != null ? `$${p.charge}` : "—"}</td>
                    <td>{p.hours_before ?? "—"}</td>
                    <td>{p.active ? "Yes" : "No"}</td>
                    <td>{p.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    </>
  );
}
